// extracted by mini-css-extract-plugin
export default {"alert":"alert-styles_component_alert__jRcRl","centerAlert":"alert-styles_component_centerAlert__OVG4p"};